import { Center, Text } from '@chakra-ui/react'

export const NotesTab = () => (
  <Center w="100%" h="100%">
    <Text fontSize="2xl" color="gray.400" fontWeight={500}>
      Notes
    </Text>
  </Center>
)
